import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioControlDietaService {

  constructor( private requestUrl: ReportesRequestService ) { }

  async getJornadasDieta(codigoBaseDatos: string) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'admision/jornadas-dieta',
        [ codigoBaseDatos, {} ]
      );
      return response;
    } catch (e) {
      console.error('ServicioControlDietaService.getJornadasDieta()', e);
    }
    return null;
  }

  async getControlDieta( filtros: FiltrosControlDietaEntity ) {
    try {
      const response = await this.requestUrl.getRequest(
        'admision/control-dieta',
        [ filtros.codigoBaseDatos,
          {
            uncoSede : filtros.uncoSede,
            inicio : filtros.inicio,
            fin: filtros.fin,
            jornadas : filtros.jornadas
          }
        ]);
      return response;
    } catch (e) {
      console.error('ServicioControlDietaService.getControlDieta()', e);
    }
    return null;
  }

}

export interface JornadasDietaEntity {
  unco: number;
  descripcion: string;
}

export interface ControlDietaEntity {
  consecutivoAdmision: string;
  nombrePaciente: string;
  puntoAtencion: string;
  descripcionCama: string;
  fechaDieta: string;
  descripcionJornadaDieta: string;
  descripcionTipoDieta: string;
  observaciones: string;
  usuarioRealiza: string;
}

export interface FiltrosControlDietaEntity {
  codigoBaseDatos ?: string;
  uncoSede ?: number;
  inicio ?: number;
  fin ?: number;
  jornadas ?: string;
}

export interface PacienteControlDietaGroup {
  paciente: string;
  fechas: FechaControlDietaGroup[];
  data ?: ControlDietaEntity[];
  rowsSpan ?: number;
  inicio ?: number;
}

export interface FechaControlDietaGroup {
  fecha: string;
  jornadas: JornadaControlDietaGroup[];
  data ?: ControlDietaEntity[];
  rowsSpan ?: number;
  inicio ?: number;
}

export interface JornadaControlDietaGroup {
  jornada: string;
  data: ControlDietaEntity[];
  inicio ?: number;
}
